
import { Route, Routes, Navigate } from "react-router-dom";
import { Suspense } from "react";
import { useSessionContext } from "@supabase/auth-helpers-react";

import Index from "@/pages/Index";
import Shop from "@/pages/Shop";
import Borrowers from "@/pages/Borrowers";
import Lenders from "@/pages/Lenders";
import Vendors from "@/pages/Vendors";
import RealEstate from "@/pages/RealEstate";
import PropertyDetails from "@/pages/real-estate/PropertyDetails";
import Cart from "@/pages/Cart";
import Register from "@/pages/auth/Register";
import SignIn from "@/pages/auth/SignIn";

import { RoutePermissionCheck } from "@/components/auth/RoutePermissionCheck";
import { borrowerRoutes } from "@/routes/borrowerRoutes";
import adminRoutes from "@/routes/adminRoutes";
import lenderRoutes from "@/routes/lenderRoutes";
import vendorRoutes from "@/routes/vendorRoutes";
import { routeConfig } from "@/components/navigation/configs/routeConfig";
import Layout from "@/components/Layout";

export const AppRoutes = () => {
  const { session } = useSessionContext();

  return (
    <Suspense fallback={<div className="p-8">Loading...</div>}>
      <Routes>
        <Route element={<Layout>{<Index />}</Layout>} path="/" />
        <Route element={<Layout>{<Shop />}</Layout>} path="/shop" />
        <Route element={<Layout>{<Shop />}</Layout>} path="/shop/products/:id" />
        <Route element={<Layout>{<Borrowers />}</Layout>} path="/borrowers" />
        <Route element={<Layout>{<Lenders />}</Layout>} path="/lenders" />
        <Route element={<Layout>{<Lenders />}</Layout>} path="/lender/:id" />
        <Route element={<Layout>{<Vendors />}</Layout>} path="/vendors" />
        <Route element={<Layout>{<RealEstate />}</Layout>} path="/real-estate" />
        <Route element={<Layout>{<PropertyDetails />}</Layout>} path="/real-estate/:id" />
        <Route element={<Layout>{<Cart />}</Layout>} path="/cart" />
        <Route element={<Layout>{<Register />}</Layout>} path="/register" />
        <Route element={<Layout>{<SignIn />}</Layout>} path="/signin" />

        {/* Borrower Routes - Fixed structure */}
        {borrowerRoutes[0].children?.map((childRoute) => (
          <Route
            key={`borrower-${childRoute.path}`}
            path={`/borrower/${childRoute.path}`}
            element={
              <Layout>
                <RoutePermissionCheck
                  allowedRoles={["borrower"]}
                  redirectPath="/signin"
                >
                  {childRoute.element}
                </RoutePermissionCheck>
              </Layout>
            }
          />
        ))}

        {/* Admin Routes */}
        {adminRoutes.map((route) => (
          <Route 
            key={route.path} 
            path={route.path} 
            element={<Layout>{route.element}</Layout>} 
          />
        ))}

        {/* Lender Routes */}
        {lenderRoutes.map((route) => (
          <Route 
            key={route.path} 
            path={route.path} 
            element={<Layout>{route.element}</Layout>} 
          />
        ))}

        {/* Vendor Routes */}
        {vendorRoutes.map((route) => (
          <Route 
            key={route.path} 
            path={route.path} 
            element={<Layout>{route.element}</Layout>} 
          />
        ))}

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  );
};
